import React, { useState, useEffect, useCallback } from 'react';
import { Grid, Divider, Typography, Box, Tab, Tabs, Card, CardContent } from '@material-ui/core';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import WaitingTimer from './WaitingTimer.jsx';
import { useTranslation } from 'react-i18next';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role='tabpanel' hidden={value !== index} id={`scrollable-auto-tabpanel-${index}`} aria-labelledby={`scrollable-auto-tab-${index}`} {...other}>
      {value === index && (
        <Box p={0}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,

    '& .MuiTabs-scrollButtons': {
      backgroundColor: '#BDB7B9',
      borderRadius: '5px',
      margin: '3px 0px',
      width: '22px',
      height: '36px',
      opacity: '1',
    },
    '& .MuiTabScrollButton-root.Mui-disabled': {
      opacity: '0.5',
    },
    '& .MuiTabs-scroller': {
      marginLeft: '3px',
      marginRight: '3px',
    },
  },
  indicator: {
    background: 'none',
  },
  tabs: {
    marginTop: '10px',
    "& button[aria-selected='true']": {
      backgroundColor: '#2883D4',
      borderRadius: '5px',
      color: 'white',
      margin: '3px',
      minWidth: '48px',
      minHeight: '22px',
    },
    "& button[aria-selected='false']": {
      backgroundColor: '#828282',
      borderRadius: '5px',
      color: 'white',
      margin: '3px',
      minWidth: '48px',
      minHeight: '22px',
    },
  },
  grid: {
    margin: '4px -4px',
  },
  Card_VB: {
    backgroundColor: '#B9B9B9',
    justifyContent: 'center',
    textAlign: 'center',
    height: '77px',
  },
  Card_VB_2: {
    backgroundColor: '#B9B9B9',
    justifyContent: 'center',
    textAlign: 'center',
    height: '92px',
  },
  Card_Content: {
    padding: '15px !important',
  },
}));

export default function VBoard(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const { agentGroups, vboardStats } = props;
  const [finalVBoard, setFinalVBoard] = useState([]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const FilterVBoard = useCallback(() => {
    for (const agentKey in agentGroups) {
      //console.log(agentGroups);
      let agentObj = agentGroups[agentKey];
      for (const vboardKey in vboardStats) {
        let vboardObj = vboardStats[vboardKey];
        //console.log(vboardObj);
        if (vboardObj['GroupNumber'] == agentObj['GroupNumber']) {
          vboardObj['QueueAbr'] = agentObj['QueueAbr'];
          vboardObj['CurrentSeconds'] = Math.floor(new Date().getTime() / 1000) - parseInt(vboardObj['ListStats'][10].StatValue);
          setFinalVBoard((finalVBoard) => [...finalVBoard, vboardObj]);
          //console.log(vboardObj);
          break;
        }
      }
    }
  });

  useEffect(() => {
    FilterVBoard();
    //console.log(vboardStats);
    return () => {
      //console.log('effect returned');
      setFinalVBoard([]);
    };
  }, [vboardStats]);

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <Divider />
        <div className={classes.root}>
          <Tabs className={classes.tabs} classes={{ indicator: classes.indicator }} value={value} onChange={handleChange} variant='scrollable' scrollButtons='on' aria-label='Scrollable Tabs'>
            {finalVBoard.map((data, index) => (
              <Tab label={data['QueueAbr'] + ' ' + data['ListStats'][2].StatValue} key={index} {...a11yProps(index)} />
            ))}
          </Tabs>
          {finalVBoard.map((data, index) => (
            <TabPanel key={index} value={value} index={index}>
              <Grid container justify='center' spacing='1'>
                <Grid item xs={6}>
                  <Card className={classes.Card_VB}>
                    <CardContent className={classes.Card_Content}>
                      <Typography variant='body2' style={{ color: '#000' }}>
                        {t('vboard.callswaiting')}
                      </Typography>
                      <Typography variant='body2' style={{ color: 'green', fontSize: '22px' }}>
                        {data['ListStats'][10].StatValue}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={6}>
                  <Card className={classes.Card_VB}>
                    <CardContent className={classes.Card_Content}>
                      <Typography variant='body2' style={{ color: '#000' }}>
                        {t('vboard.callsabandoned')}
                      </Typography>
                      <Typography variant='body2' style={{ color: 'red', fontSize: '22px' }}>
                        {data['ListStats'][8].StatValue}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
              <Grid container justify='center' className={classes.grid} spacing='1'>
                <Grid item xs={6}>
                  <Card className={classes.Card_VB}>
                    <CardContent className={classes.Card_Content}>
                      <Typography variant='body2' style={{ color: '#000' }}>
                        {t('vboard.longestwaiting')}
                      </Typography>
                      <Typography variant='body2' style={{ color: '#000', fontSize: '22px' }}>
                        {data['ListStats'][9].StatValue !== '0' ? <WaitingTimer timerState={true} waitingSeconds={Math.floor(new Date().getTime() / 1000) - data['CurrentSeconds']} /> : '00:00:00'}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={6}>
                  <Card className={classes.Card_VB}>
                    <CardContent className={classes.Card_Content}>
                      <Typography variant='body2' style={{ color: '#000' }}>
                        {t('vboard.servicelevel')}
                      </Typography>
                      <Typography variant='body2' style={{ color: '#000', fontSize: '22px' }}>
                        {data['ListStats'][4].StatValue}%
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
              <Grid container justify='center' spacing='1'>
                <Grid item xs={4}>
                  <Card className={classes.Card_VB_2}>
                    <CardContent className={classes.Card_Content}>
                      <Typography variant='body2' style={{ color: '#000' }}>
                        {t('vboard.agents')}
                        <br />
                        {t('vboard.loggedin')}
                      </Typography>
                      <Typography variant='body2' style={{ color: '#000', fontSize: '22px' }}>
                        {data['ListStats'][3].StatValue}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={4}>
                  <Card className={classes.Card_VB_2}>
                    <CardContent className={classes.Card_Content}>
                      <Typography variant='body2' style={{ color: '#000' }}>
                        {t('vboard.agents')}
                        <br />
                        {t('vboard.available')}
                      </Typography>
                      <Typography variant='body2' style={{ color: '#000', fontSize: '22px' }}>
                        {data['ListStats'][2].StatValue}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={4}>
                  <Card className={classes.Card_VB_2}>
                    <CardContent className={classes.Card_Content}>
                      <Typography variant='body2' style={{ color: '#000' }}>
                        {t('vboard.agents')}
                        <br />
                        {t('vboard.busy')}
                      </Typography>
                      <Typography variant='body2' style={{ color: '#000', fontSize: '22px' }}>
                        {data['ListStats'][1].StatValue}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </TabPanel>
          ))}
        </div>
      </Grid>
    </React.Fragment>
  );
}
